import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { incidentsQueryKeys } from "./queryKeys"
import { useIncidentsQuery } from "./useIncidentsQuery"

export function useNetwork(
    queryParameters,
    config = {},
) {
    const { enabled = true } = config
    const { selectedNetwork } = useNetworksStateContext()
    const url = `projects/${selectedNetwork?.slug}/`

    return useIncidentsQuery(
        url,
        incidentsQueryKeys["network"](),
        queryParameters,
        {
            ...config,
            enabled: !!selectedNetwork?.slug && enabled,
        },
    )
}
